import { render, staticRenderFns } from "./MoveText.vue?vue&type=template&id=0f6ab3fc&scoped=true&"
import script from "./MoveText.vue?vue&type=script&lang=js&"
export * from "./MoveText.vue?vue&type=script&lang=js&"
import style0 from "./MoveText.vue?vue&type=style&index=0&id=0f6ab3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6ab3fc",
  null
  
)

export default component.exports